import CheckableTagList from './checkableTagList';

export default CheckableTagList;
